import { Box, getVariant, Heading, Image } from '@apia/theme';
import { HeaderButtons } from './HeaderButtons';

interface IHeader {
  title: string;
  description?: string;
  image?: string;
}

export const Header = ({ title, description, image: imageUrl }: IHeader) => {
  return (
    <header>
      <Box className="imageTitleAndDescription">
        <Box className="image">
          <Image src={imageUrl ?? ''} role="presentation" alt="" />
        </Box>
        <Box className="titleAndDescription">
          <Heading {...getVariant('text.title')} as="h1">
            <Box as="span">{title}</Box>
          </Heading>
          <Box as="p" className="description">
            {description ?? ''}
          </Box>
        </Box>
      </Box>
      <HeaderButtons />
    </header>
  );
};
